/**
 * App Constants — MangoTV
 * Pattern: mirrors glotv constants.js
 */

export const APP_NAME = "OpenPlay";
export const APP_TAGLINE = "Life, Upgraded.";

// Email regex (matches glotv)
export const EMAIL_REGEXP = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: "mango_access_token",
  REFRESH_TOKEN: "mango_refresh_token",
  TOKEN_EXPIRY: "mango_token_expiry",
  AUTHENTICATED: "mango_authenticated",
  API_URL: "mango_client_api_url",
  SELECTED_OPERATOR: "mango_selected_operator",
  EMAIL: "mango_email",
  USERNAME: "mango_username",
};

// Log messages (CRM /logs/ event descriptions — matches glotv pattern)
export const LOG_MESSAGES = {
  login: "User logged in",
  logout: "User logged out",
  playMovie: "User played movie",
  playSeries: "User played series",
  playLive: "User played live channel",
  search: "User searched for content",
  quit: "User closed web client",
};

// Error Messages (matches glotv pattern)
export const ERROR_MESSAGES = {
  AUTH: {
    wrongOTP: "Invalid OTP code",
    invalidEmail: "Please enter a valid email address",
    invalidPassword: "Your password should be a minimum of 7 characters",
    passwordMismatch: "Passwords do not match",
    invalidLogin: "Invalid login credentials",
    invalidAccount:
      "Invalid user account. Try again or contact support",
  },
  VERIFICATION: {
    invalidNetwork: "Please continue with a valid network",
  },
  SUBSCRIPTION: {
    subscriptionFailed: "Subscription was unsuccessful",
    subscriptionCancel: "Failed to cancel subscription",
  },
  NETWORK_ERROR: "Unable to connect. Please check your internet connection.",
  SESSION_EXPIRED: "Your session has expired. Please sign in again.",
  GENERIC_ERROR: "Something went wrong. Please try again later.",
};
